angular.module('hcap-analytics')
.directive('scorebar', [
  function(
  ) {
    const heightMax = 90;
    const heightMin = 10;

    function staggeredHeights(markCount) {
      if (markCount <= 1) {
        return [heightMax];
      }

      const step = (heightMax - heightMin) / (markCount - 1);
      return [...Array(markCount).keys()].map(index => _.round(heightMax - (index * step), 2));
    }

    return {
      scope: {
        marksRaw: '<marks',
        startRange: '<',
        endRange: '<',
        maxScore: '<',
        legendMarkTexts: '<?',
        legendRangeText: '<?',
        legendSampleText: '<?',
        markTypes: '<?',
      },
      templateUrl: 'templates/scorebar.html',
      restrict: 'E',
      link: function($scope, $element, $attrs) {
        $scope.marks = $scope.marksRaw.map(d => _.round(+d, 1));
        $scope.legendTexts = $scope.legendMarkTexts || [];

        $scope.marks.forEach((m, i) => {
          $scope.legendTexts[i] = $scope.legendTexts[i] || '';
        });

        const typeColorMap = {
          personal: 'primary',
          others: 'success',
          pop: 'info',
          'cohort-self': 'warning',
          'cohort-rater': 'secondary',
          variable: 'variable',
        };

        const colorFallbacks = ['primary', 'success', 'info'];
        const heights = staggeredHeights($scope.marks.length);

        $scope.markStyle = [];
        $scope.legendStyle = [];

        $scope.marks.forEach((s, i) => {
          const color = $scope.markTypes && typeColorMap[$scope.markTypes[i]] || colorFallbacks[i] || 'info';
          const markStyle = {
            left: `${s / $scope.maxScore * 100}%`,
            'z-index': i,
          };
          const legendStyle = {};
          let colorCss = `var(--${color})`;

          if ('variable' === color) {
            colorCss = `var(--scorebar-mark-start)`;
            markStyle.filter = `hue-rotate(${i * 360 / $scope.marks.length}deg)`;
            markStyle.height = heights[i];
            legendStyle.filter = `hue-rotate(${i * 360 / $scope.marks.length}deg)`;
          } else {
            markStyle.height = heights[i];
          }

          legendStyle['background-color'] = colorCss;
          markStyle['border-left-color'] = colorCss;
          markStyle.score = {
            'background-color': colorCss,
          };

          $scope.markStyle.push(markStyle);
          $scope.legendStyle.push(legendStyle);
        });

        const startRange = $scope.startRange / $scope.maxScore;
        const endRange = $scope.endRange / $scope.maxScore;
        $scope.rangeStyle = {
          left: startRange * 100 + '%',
          width: (endRange - startRange) * 100 + '%',
        };

        $scope.ticks = [...Array($scope.maxScore + 1).keys()];
      },
    };
  },
]);
